<template>
    <v-container class="login-content-wrapper">
        <v-layout wrap fill-height align-center justify-center>
            <v-flex xs12 text-center>
                <v-layout wrap class="content py-3" justify-center align-center >

                    <v-scale-transition>
                        <v-layout wrap v-show="!currentUser">

                            <v-flex xs12 text-center >
                                <v-img class="mx-auto my-2"
                                       :src="require('@/assets/img/logo/logo_transparent_background.png')"
                                       width="100%" max-width="300" />
                            </v-flex>

                            <v-flex xs12 text-center mt-1>
                               <v-layout wrap justify-center>
                                    <v-flex xs12 md8 lg4 text-center>
                                        <standalone-login-form  v-on:success="onLoginSuccess"/>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                        </v-layout>
                    </v-scale-transition>

                    <div class="bottom-advertise" v-show="false">
                        <p class="caption font-weight-light grey--text mt-2 mb-1">Terminos y condiciones</p>
                    </div>

                </v-layout>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
    import StandaloneLoginForm from '../components/common/StandaloneLoginForm'

    import {mapState} from 'vuex'

    export default {
        components: {
          StandaloneLoginForm,
        },
        data(){
            return {
                showSpecialistSignUp: false
            }
        },
        computed:{
            ...mapState(['currentUser', 'firstLoadingLogin']),
        },
        methods:{
            onLoginSuccess(){

                const failedUrl = localStorage.failedUrl

                if(failedUrl){
                    localStorage.failedUrl = ''
                    this.$router.replace(failedUrl)
                }else{
                    this.$router.replace({
                        name: 'panel.dashboard'
                    })
                }
            },
            onChange(show){
                this.showSpecialistSignUp = show
            },
        }
    }
</script>

<style scoped>

    .loading-wrapper{
        position: absolute;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logo{
        margin: auto;
        max-width: 1024px;
        background-size: 30%;
        background-repeat: no-repeat;
        background-position: center;
    }

    @media screen and (max-width: 500px){
        .logo{
            height: 70px;
            background-size: 100%;
        }
    }

    @media screen and (max-width: 700px){
        .logo{
            background-size: 70%;
        }
    }

    .content{
        position: relative;
        z-index: 10;
    }

    .bottom-advertise{
        position: fixed;
        bottom: 10px;
        text-align: center;
        background: rgba(0,0,0,.3);
        padding: 2px 15px;
        border-radius: 5px;
    }

    #bg-video{
        position: fixed;
        text-align: center;
        z-index: 0;
        right: 0;
        bottom: 0;
        min-width: 100%;
        min-height: 100%;
    }

    .bg-overlay{
        position: fixed;
        z-index: 1;
        right: 0;
        bottom: 0;
        min-width: 100%;
        min-height: 100%;

        background:rgba(255, 255, 255, 0.75)

    }

    @media screen and (min-width: 600px){

        #bg-video{
            filter: blur(3px)
        }

        .bg-overlay{
            background: rgba(255, 255, 255, 0.75)
        }
    }

</style>
